import React, { useState, useEffect } from "react";
import { Button, Loader } from "@ADC/components/common";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { faqs as localFaqsData } from "@ADC/data";

import "./Faqs.css";

const FAQs = ({ isApplyPage = false }) => {
  const [showAllQoestions, setShowAllQoestions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [FAQs, setFAQs] = useState([]);
  const qoestions = showAllQoestions
    ? FAQs
      ? FAQs
      : localFaqsData
    : FAQs
    ? FAQs?.slice(0, 5)
    : localFaqsData.slice(0, 5);

  const getAllFaqs = async () => {
    setLoading(true);
    const faqsRes = await fetch(
      `${process.env.ADC_API_URL}/adc-faqs?populate=*&sort=id:asc`
    );
    const faqsData = await faqsRes.json();
    setFAQs(faqsData?.data);
    setLoading(false);
  };

  useEffect(() => {
    getAllFaqs();
  }, []);

  return (
    <section className="bg-white py-16" id="faqs">
      <div className="text-center mb-[35px]">
        <h2 className="text-[55.25px] leading-[77.95px] text-[#3A9746] font-bold">
          FAQ’S
        </h2>
      </div>
      <div className="max-w-[845px] mx-auto px-4 tab:px-0">
        {loading ? (
          <Loader />
        ) : (
          <>
            {qoestions.map((faq, index) => (
              <Accordion
                className="mb-8 !bg-[#f4f5f7] !rounded-lg !shadow-none overflow-hidden"
                key={index}
              >
                <AccordionSummary
                  className="!py-[22px] !ps-[46px] !pe-[14px] text-xl md:text-[24px] font-semibold m-0 relative"
                  expandIcon={
                    <ExpandMoreIcon className="!text-3xl !font-light" />
                  }
                  sx={{
                    "& .MuiAccordionSummary-content": {
                      margin: "0 !important",
                    },
                    "& .MuiAccordionSummary-expandIconWrapper": {
                      position: "absolute",
                      left: "9px",
                    },
                  }}
                >
                  {FAQs ? faq?.attributes?.question : faq?.title}
                </AccordionSummary>
                <AccordionDetails className="!ps-[46px] pt-0 pb-10 text-lg font-light answer">
                  {FAQs ? (
                    <BlocksRenderer content={faq?.attributes?.answer} />
                  ) : (
                    faq?.content
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
            {isApplyPage && (
              <div className="w-full py-8 mt-12 bg-custom-yellowLight flex flex-col items-center justify-center rounded-[32px]">
                <img src="/svgs/icons/personal-finance.svg" alt="Finance" />
                <h4 className="text-3xl sm:text-[42px] font-medium text-custom-primary my-8">
                  Still have questions?
                </h4>
                <Button
                  label="800-971-4060"
                  variant="primary"
                  link={{
                    is: true,
                    isExternal: true,
                    path: "tel:800-971-4060",
                  }}
                  showLeftCallIcon
                />
              </div>
            )}
          </>
        )}
      </div>
      <Button
        onPress={() => setShowAllQoestions(true)}
        className={`capitalize mt-10 mx-auto ${showAllQoestions && "hidden"}`}
        label="read more"
        variant="outline"
      />
    </section>
  );
};

export default FAQs;
